import { render, staticRenderFns } from "./JournalList.vue?vue&type=template&id=1e8fb7e7"
import script from "./JournalList.vue?vue&type=script&lang=js"
export * from "./JournalList.vue?vue&type=script&lang=js"
import style0 from "./JournalList.vue?vue&type=style&index=0&id=1e8fb7e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports